// Идемпотентность для мутаций Pickem (см. docs/pickem/docs/technical/13-frontend-protection.md):
// «UUIDv4 на одно логическое действие, не на клик».
//
// Композабл выдаёт ключ один раз для одной серии попыток (например, click → ретрай через 5с
// при ошибке сети). Когда действие гарантированно завершилось — нужно вызвать `reset()`,
// чтобы следующее действие получило свежий ключ.
//
// crypto.randomUUID есть в современных браузерах и в Node 19+. Для SSR-fallback используем
// Math.random — для idempotency этого достаточно (нужна низкая вероятность коллизии
// в рамках одной сессии юзера, не глобальная уникальность).

const fallbackUuid = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })

export const generateIdempotencyKey = (): string => {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID()
  }
  return fallbackUuid()
}

// Удерживает один и тот же ключ до явного reset(). Используется так:
//   const { key, reset } = useIdempotencyKey()
//   await sdkModule.upsertSwissPrediction(body, key.value)
//   reset()
// Если запрос упал — ключ не сбрасываем, ретрай отправит тот же → бэк ответит закешированным.
export const useIdempotencyKey = () => {
  const key = ref(generateIdempotencyKey())

  const reset = () => {
    key.value = generateIdempotencyKey()
  }

  return { key, reset }
}
